module.exports = __webpack_public_path__ + "59cc902cd877fd836fbcabdbb6a5b9.png";